import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const AttachIcon: TIconType = (props?: IIconProps) => {
	const width = props?.width || '24';
	const height = props?.height || '24';
	const color = props?.color || colors.indigo70;

	return (
		<svg
			fill='none'
			height={height}
			viewBox='0 0 24 24'
			width={width}
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_34709_89934)'>
				<path
					d='M19.8987 11.5989C19.951 11.6512 19.9925 11.7132 20.0208 11.7815C20.0491 11.8498 20.0637 11.923 20.0637 11.9969C20.0637 12.0708 20.0491 12.144 20.0208 12.2123C19.9925 12.2806 19.951 12.3426 19.8987 12.3949L12.2056 20.0824C11.2559 21.0317 9.96802 21.5648 8.62523 21.5646C7.28244 21.5643 5.99476 21.0306 5.04545 20.0809C4.09614 19.1313 3.56297 17.8434 3.56323 16.5006C3.5635 15.1578 4.09717 13.8701 5.04685 12.9208L14.3534 3.47829C14.6841 3.1473 15.0767 2.88468 15.5089 2.70543C15.9411 2.52618 16.4043 2.43381 16.8722 2.43359C17.3401 2.43338 17.8034 2.52532 18.2358 2.70416C18.6681 2.88301 19.061 3.14526 19.392 3.47595C19.723 3.80663 19.9856 4.19927 20.1649 4.63145C20.3441 5.06363 20.4365 5.52688 20.4367 5.99476C20.4369 6.46264 20.345 6.92598 20.1661 7.35832C19.9873 7.79067 19.725 8.18355 19.3944 8.51454L10.0869 17.9533C9.70034 18.3406 9.17582 18.5584 8.62868 18.5589C8.08155 18.5595 7.55661 18.3426 7.16935 17.9561C6.78209 17.5696 6.56424 17.0451 6.56371 16.4979C6.56318 15.9508 6.78003 15.4259 7.16654 15.0386L14.974 7.10079C15.0787 6.99437 15.2214 6.9339 15.3706 6.93267C15.5199 6.93144 15.6636 6.98955 15.77 7.09423C15.8764 7.19891 15.9369 7.34157 15.9381 7.49084C15.9393 7.64011 15.8812 7.78375 15.7765 7.89017L7.96904 15.8317C7.88175 15.9186 7.81243 16.0218 7.76502 16.1354C7.71762 16.2491 7.69306 16.371 7.69276 16.4941C7.69245 16.6172 7.7164 16.7392 7.76325 16.8531C7.81009 16.967 7.8789 17.0705 7.96576 17.1578C8.05262 17.2451 8.15581 17.3144 8.26946 17.3618C8.38311 17.4092 8.50499 17.4338 8.62813 17.4341C8.75127 17.4344 8.87326 17.4105 8.98714 17.3636C9.10102 17.3168 9.20456 17.248 9.29185 17.1611L18.5956 7.72142C19.0531 7.26467 19.3104 6.64488 19.3109 5.99841C19.3115 5.35193 19.0552 4.73173 18.5984 4.27423C18.1417 3.81673 17.5219 3.55942 16.8754 3.55889C16.2289 3.55836 15.6087 3.81467 15.1512 4.27142L5.84373 13.7102C5.10477 14.4483 4.68928 15.4497 4.68866 16.4941C4.68805 17.5385 5.10236 18.5404 5.84045 19.2794C6.57854 20.0183 7.57994 20.4338 8.62438 20.4345C9.66881 20.4351 10.6707 20.0208 11.4097 19.2827L19.1028 11.5952C19.1553 11.5431 19.2175 11.5019 19.2859 11.4739C19.3543 11.4459 19.4276 11.4317 19.5015 11.4321C19.5755 11.4324 19.6486 11.4473 19.7167 11.476C19.7849 11.5046 19.8467 11.5464 19.8987 11.5989Z'
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id='clip0_34709_89934'>
					<rect
						fill='white'
						height={height}
						width={width}
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default AttachIcon;
